const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/alarm-execution-logs/`
export const CLIENT_ALARM_EXECUTION_LOG_PATH = `api/${apiVersion}/clients/:client_session_id/alarms/`
